namespace GeniuzPOS.ReportMasterData {
    export class Report_1403Columns {
        static columnsKey = 'ReportMasterData.Report_1403';
    }
}
